export const nav = [
  {
    id: 1,
    text: "home",
    url: "/",
  },
  {
    id: 2,
    text: "taarabot",
    url: "https://console.dialogflow.com/api-client/demo/embedded/9ceb4ad7-b3a7-49eb-b8e1-9b72a12e79cb",
  },
  {
    id: 3,
    text: "blog",
    url: "/blogs",
  },
  {
    id: 4,
    text: "Shelter",
    url: "/shelter",
  },
  {
    id: 5,
    text: "Jobs",
    url: "/jobs",
  },
  {
    id: 6,
    text: "Legal",
    url: "/legal",
  },
  {
    id: 7,
    text: "Gallery",
    url: "/gallery",
  },
  {
    id: 8,
    text: "Calming Corner",
    url: "/music",
  },
  {
    id: 9,
    text: "Quiz",
    url: "/quiz",
  },
   {
    id: 10,
    text: "FAQ",
    url: "/faq",
  },
];
export const category = [
  {
    id: 1,
    category: "",
    title: "Stay Calm And Surf",
    cover: "../images/category/ca1.png",
  },
  {
    id: 2,
    category: "",
    title: "Becoming a Dragonfly",
    cover: "../images/category/ca2.png",
  },
  {
    id: 3,
    category: "",
    title: "There's always light at the end of the tunnel",
    cover: "../images/category/ca3.png",
  },
  {
    id: 4,
    category: "Sport",
    title: "Stay Calm And Surf",
    cover: "../images/category/ca4.png",
  },
  {
    id: 5,
    category: "Fun",
    title: "There's always light at the end of the tunnel",
    cover: "../images/category/ca5.png",
  },
  {
    id: 6,
    category: "Health",
    title: "Becoming a Dragonfly",
    cover: "../images/category/ca6.png",
  },
  {
    id: 7,
    category: "Business",
    title: "Stay Calm And Surf",
    cover: "../images/category/ca7.png",
  },
  {
    id: 8,
    category: "Technology",
    title: "There's always light at the end of the tunnel",
    cover: "../images/category/ca8.png",
  },
];
export const images = [
  {
    id: 1,
    src: "https://cdn.culturecrossroads.ca/posts/zarine-khan-attended-the-third-national-transgender-awards/images/img_2967_hu94a35130b4a0216e97ee72418d84ba68_188308_800x0_resize_q90_r360_h2_lanczos.webp",
    alt: "Transgender Award Ceremony",
  },
  {
    id: 2,
    src: "https://communityshares.com/wp-content/uploads/2021/01/outreach-photo.jpg",
    alt: "Community Outreach for Trans Rights",
  },
  {
    id: 3,
    src: "https://s3-eu-west-2.amazonaws.com/images.hospitalpharmacyeurope.com/wp-media-folder-hospital-pharmacy-europe/wp-content/uploads/2025/05/The_role_of_pharmacists_in_supporting_transgender_and_gender-diverse_patients_with_cancer.jpg",
    alt: "Team of the Organization",
  },
  {
    id: 4,
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbYBr_mmSEApz8vYmwISFEa2849ypb2d3buQ&s",
    alt: "Advocacy for LGBTQ+ Rights",
  },
  {
    id: 5,
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8-v7rC483V0ZLDk1LeKdoPDjyjxfJzz8whg&s",
    alt: "Awareness Program",
  },
  {
    id: 6,
    src: "https://a.storyblok.com/f/245693/568x379/832e1914cf/volunteers.jpg",
    alt: "Volunteers Helping the Community",
  },
];
